module.exports = __webpack_public_path__ + "static/media/immune-booster 1.6943cb92.png";